import React, { Component } from 'react'
import { TouchableOpacity, StyleSheet } from 'react-native'

export default class HoverableOpacity extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {

    return (
      <TouchableOpacity
        activeOpacity={1}
        style={[{ cursor: 'inherit' }, styles.outerStyle, this.state.hover ? styles.hoverStyle : {}]}
        onMouseEnter={() => this.setState({ hover: true })}
        onMouseLeave={() => this.setState({ hover: false })}
      >
        <TouchableOpacity {...this.props} />
      </TouchableOpacity>
    )
  }
}

  
const styles = StyleSheet.create({  
    outerStyle: {
    },
    hoverStyle:{
        opacity: 0.6
    }
})  